module.exports = __webpack_public_path__ + "static/media/icon-error.827b720a.svg";